import { useGlobalContext } from "../context";

const Modal = () => {
  const { closeModal, selectedMeal } = useGlobalContext();

  const {
    strMealThumb: image,
    strMeal: title,
    strInstructions: text,
    strSource: source,
  } = selectedMeal;
  return (
    <aside className="modal-overlay">
      <div className="modal-container">
        <img src={image} alt={title} className="img modal-img" />
        <div className="modal-content">
          <h4>{title}</h4>
          <p>Cooking instructions</p>
          <p>{text}</p>
          <a href={source} target="_blank" rel="noopener noreferrer">
            Original Source
          </a>
          <button class="btn btn-hipster close-btn" onClick={closeModal}>
            close
          </button>
        </div>
      </div>
    </aside>
  );
};
export default Modal;
